import CustomNotificationEvent from "@casino/client/events/CustomNotificationEvent";

const createChangeCurrencyNotification = (
  body: string,
  title: string,
  isRequiredToSwitch: boolean,
  currency: string,
  rewardId: string,
) => {
  CustomNotificationEvent.create({
    type: "freeBetReward",
    priority: "low",
    dismissStrategy: {},
    data: {
      id: "otherFreeBetReward",
      body,
      title,
      isRequiredToSwitch,
      currency,
      rewardId,
    },
  } as WorkerNotification);
};

export default createChangeCurrencyNotification;
